import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const ClientsListLazy = loadable(() => import(/* webpackChunkName: "ClientsList" */ './ClientsListSuspense'));

export const ClientsListAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <ClientsListLazy />
    </DelayedSuspense>
);
